<div
  [id]="id + '8bf17ffb-bf21-4aa5-880a-f94f227661ab'"
  class="panel-div spinner-dark"
  [class.delete-mode]="deleteMode === 'delete'"
  [class.delete-in-progress]="deleteMode === 'deleteInProgress'"
  [class.active]="defaultIcon === 'selected'"
  [class.minified]="minified"
  yatTabSelectable
  (tabSelect)="selectPayment($event)"
  [yatSpinner]="selectMode === 'selectInProgress' || (spinnerShown && isMobile())"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
  [matomoClickAction]="matomoEventClickAction"
  [matomoClickName]="paymentMethod.type">
  <div [id]="id + '0ee352e1-9cbc-4777-9ae3-79aa07a1d6db'" class="row">
    <div [id]="id + 'dac9d24e-5316-463a-a8a8-664d1825c2b0'" class="col-12">
      <div [id]="id + '4a7b464d-1675-43ae-8cf9-ca0b622930aa'" class="icons skeleton-hide">
        <span
          [id]="id + '667886af-c399-47a8-915f-f183423600ff'"
          class="no-select"
          yatTabSelectable
          (tabSelect)="prepareDelete()"
          *ngIf="liveLicense && showDeleteIcon"
          [yatTooltip]="('delete' | commonWording | async) ?? ''"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
          matomoClickAction="Select_DeletePaymentMethod"
          [matomoClickName]="paymentMethod.type">
          <yat-icon id="37be500e-9a75-4aa6-928b-f83fbbbf5366" [class.hover-icon]="!isMobile()" name="delete-duo"></yat-icon>
        </span>
        <span
          [id]="id + '9a010ee8-732d-427d-937d-7dfafdf91acc'"
          class="no-select"
          *ngIf="liveLicense && showEditIcon"
          yatTabSelectable
          (tabSelect)="edit()"
          [yatTooltip]="('edit' | commonWording | async) ?? ''"
          [yatTooltip]="('edit' | commonWording | async) ?? ''"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
          matomoClickAction="Select_ModifyPaymentMethod"
          [matomoClickName]="paymentMethod.type">
          <yat-icon id="7f7143a4-1301-4370-802e-a4c543c80312" [class.hover-icon]="!isMobile()" name="edit-field-duo"></yat-icon>
        </span>
        <div [id]="id + 'af3e4258-5939-4113-bfdd-c7ddaaba4c4b'" class="vr" *ngIf="liveLicense && (showDeleteIcon || showEditIcon)"></div>
        <ng-container *ngIf="defaultIcon || isMobile(); else noDefaultIcon">
          <span [id]="id + '2d5ace97-00d4-4b98-bae3-1acb8f19d748'" class="icon-static" *ngIf="(isMobile() && showDeleteIcon !== false) || !isMobile()">
            <yat-icon
              [class.hover-icon]="!isMobile()"
              class="p-1 mr-1"
              *ngIf="(defaultIcon === 'settings' || (isMobile() && defaultIcon === 'selected' && liveLicense)) && !minified"
              name="cog-duo"></yat-icon>
            <yat-icon *ngIf="defaultIcon === 'selected'" name="tick-circle-duo" class="active"></yat-icon>
          </span>
        </ng-container>
        <ng-template #noDefaultIcon>
          <span [id]="id + 'c4beed60-a5f1-4a2f-81ea-0938dae256ed'">
            <yat-icon id="e0fa62b8-c8fe-477d-88a3-3eb3c6793ffe" name="tick-circle-duo"></yat-icon>
          </span>
        </ng-template>
      </div>
      <yat-mobile-draw-dialog
        [id]="id + 'cd54ece5-ff83-40c5-81bb-aa5ef6fff35e'"
        [showDialog]="deleteMode !== 'default' && deleteMode !== 'deleteInProgress' && isMobile() && (showDeleteIcon || showEditIcon)"
        (abortConfirmModal)="abortConfirmDelete()"
        [showSecondConfirmDialogFlag]="showSecondConfirmDialogFlag">
        <ng-container ngProjectAs="primaryMenu">
          <span
            *ngIf="showEditIcon"
            [id]="id + '2262a456-40cd-4369-840f-68867a9bcca8'"
            yatTabSelectable
            (tabSelect)="edit()"
            [yatTooltip]="('edit' | commonWording | async) ?? ''"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
            matomoClickAction="Select_ModifyPaymentMethod"
            [matomoClickName]="paymentMethod.type">
            <yat-icon id="1d3fdd02-dacb-4d29-92ec-14d629f2b7ee" name="edit-field-duo"></yat-icon> {{ 'edit' | commonWording | async }}
          </span>
          <span
            *ngIf="liveLicense && showDeleteIcon"
            [id]="id + '9904c81d-e7da-4341-a675-730b627014ee'"
            class="delete"
            yatTabSelectable
            (tabSelect)="showSecondConfirmDialog()"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
            matomoClickAction="Select_DeletePaymentMethod"
            [matomoClickName]="paymentMethod.type">
            <yat-icon id="fec038e4-b0d2-4944-8e3d-b571fbc35cf4" name="delete-duo"></yat-icon> {{ 'delete' | commonWording | async }}
          </span>
        </ng-container>
        <ng-container ngProjectAs="secondaryMenu">
          <p [id]="id + '876f1419-2d35-402a-a173-79aef6ef3712'">
            {{ 'checkout.paymentInformation.paymentMethodModal.paymentMethodConfirmDelete' | transloco }}
          </p>
          <div [id]="id + 'ca56deb2-e20c-4ded-b656-4cddd31a6136'" class="buttons-container">
            <button
              [id]="id + '220bbeee-dd23-4f81-bcf0-cd43b9dbe6cd'"
              yat-button
              type="button"
              class="btn secondary-weak"
              (click)="abortConfirmDelete()"
              [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
              matomoClickAction="Cancel_DeletePaymentMethod"
              [matomoClickName]="paymentMethod.type">
              {{ 'cancel' | commonWording | async }}
            </button>
            <button
              [id]="id + 'b69e95b8-84dd-4d0e-953a-6a600daade36'"
              yat-button
              type="button"
              class="btn primary destructive"
              (click)="deleteItem()"
              [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
              matomoClickAction="Confim_DeletePaymentMethod"
              [matomoClickName]="paymentMethod.type">
              {{ 'delete' | commonWording | async }}
            </button>
          </div>
        </ng-container>
      </yat-mobile-draw-dialog>
      <div *ngIf="!liveLicense" [id]="id + '60c7932c-616f-4cf9-a8fa-f6f6aaf3b07d'" class="demo skeleton-hide">{{ 'demo' | commonWording | async }}</div>
      <ng-container *ngIf="paymentMethod.type === 'CREDIT_CARD'">
        <p [id]="id + '2284cc2b-03c2-41c6-ad3d-aa61a64f5951'" class="beside-icons credit-card-title">
          <yat-icon id="46151809-b93a-4802-86ff-b280ced90c98"
            class="payment-method-icon"
            [name]="paymentMethod.cardType | cardTypeIcon"
            [title]="paymentMethod.cardType | cardTypeDescription | async"
            [multiColored]="true"></yat-icon>
          <span class="credit-card-number">**** {{ paymentMethod.maskedNumber }}</span>
        </p>
        <p *ngIf="!minified" [id]="id + 'f44d8a4d-937c-46ba-b169-82b564567a4b'">
          {{ paymentMethod.holderName }}
          <span [id]="id + '553ef446-ee62-4993-8b99-bcdba19e063f'" class="c-gray d-block">
            {{
              'checkout.paymentInformation.paymentMethodPanel.expires'
                | transloco: { expiryDate: (paymentMethod.expiryMonth | number: '2.0-0') + '/' + paymentMethod.expiryYear }
            }}
          </span>
        </p>
      </ng-container>
      <ng-container *ngIf="paymentMethod.type === 'DIRECT_DEBIT'">
        <yat-icon *ngIf="!minified" class="payment-method-icon" [name]="'sepa'" [multiColored]="true"></yat-icon>
        <p *ngIf="!minified" [id]="id + '55ba1a59-b488-4e68-b1c3-7a9c0aa27e3c'" class="beside-icons">{{ 'sepaDirectDebit' | commonPaymentWording | async }}</p>
        <div *ngIf="!minified" [id]="id + '1348a5c0-93ed-4a62-807a-31f0519e5fef'">
          <p [id]="id + 'a8b2ed35-4c9c-4e45-bc53-a990e3b8c264'" class="beside-icons">
            {{ paymentMethod.bank }}
          </p>
        </div>
        <p *ngIf="!minified" [id]="id + 'f36b368d-1330-444e-90b7-0243e31367d9'">
          {{ 'checkout.paymentInformation.paymentMethodPanel.iban' | transloco: { iban: paymentMethod.iban | iban } }}
          <span [id]="id + '37a5be02-ab14-455e-a25e-e2cc01fb11f4'" class="c-gray d-block">
            {{ paymentMethod.accountOwner }}
          </span>
        </p>
        <p *ngIf="minified" [id]="id + '725b64ed-8f87-486e-a680-4406a5a76985'" class="m-0">
          <yat-icon class="payment-method-icon" [name]="'sepa'" [multiColored]="true"></yat-icon>
          <span [id]="id + '37a5be02-ab14-455e-a25e-e2cc01fb11f4'" class="direct-debit-number">
            {{ paymentMethod.iban | iban }}
          </span>
        </p>
      </ng-container>
      <ng-container *ngIf="paymentMethod.type === 'PAY_PAL'">
        <p [id]="id + 'f2338264-6043-46c4-a791-e24b330b1edb'" class="beside-icons">
          <yat-icon id="de15976d-1801-4649-af33-dc1f3c3c8854" class="payment-method-icon" name="paypal-branded" [multiColored]="true"></yat-icon>
          <span [id]="id + '7102cd12-ead6-4549-97aa-c2ebd19dfc46'" class="payment-method-icon-title">{{ 'payPal' | commonPaymentWording | async }}</span>
        </p>
        <p *ngIf="!minified" [id]="id + 'b58d2b9c-cbc4-483c-ad0c-9c1817076816'">
          <span class="c-gray" [id]="id + '0c4f34f4-16a8-4d06-8764-e34bfad8899b'">
            {{ paymentMethod.emailAddress }}
          </span>
        </p>
      </ng-container>
      <ng-container *ngIf="paymentMethod.type === 'APPLE_PAY' || paymentMethod.type === 'GOOGLE_PAY'">
        <ng-container [ngSwitch]="paymentMethod.type">
          <p [id]="id + 'ee24a358-c33d-4694-a527-4ee311c8c6e8'" class="beside-icons" *ngSwitchCase="'APPLE_PAY'">
            <yat-icon id="8a8eff41-d34e-412f-872d-c12b12974eb0" class="payment-method-icon" name="apple-pay-card" [multiColored]="true"></yat-icon>
            <span [id]="id + 'd6a4f1ae-0dae-4433-9baf-e13082dc239d'" class="payment-method-icon-title">{{ 'applePay' | commonPaymentWording | async }}</span>
          </p>
          <p [id]="id + '9dd8fd11-e0d2-4165-8192-b56030e43b4e'" class="beside-icons" *ngSwitchCase="'GOOGLE_PAY'">
            <yat-icon id="28d138f9-d16d-4075-a5fd-36b5ae867dc8" class="payment-method-icon" name="google-pay-card" [multiColored]="true"></yat-icon>
            <span [id]="id + '7463102c-01bb-4d2c-bf06-3c1f266653a2'" class="payment-method-icon-title">{{ 'googlePay' | commonPaymentWording | async }}</span>
          </p>
        </ng-container>
        <p *ngIf="!minified && isPaymentMethod(paymentMethod)" [id]="id + 'e4265588-fdc0-4065-afbc-5242b356d017'">
          <span [id]="id + '9c80f0e0-b12e-4dd9-9003-83a3dfa67871'" class="c-gray">
            {{ paymentMethod.description }}
          </span>
        </p>
      </ng-container>
      <ng-container *ngIf="paymentMethod.type === 'TEAM_BUDGET'">
        <p [id]="id + 'a720361f-5801-4cfa-afd6-82a6446c2240'" class="beside-icons credit-card-title">
          <yat-icon id="b70b8e58-59b0-4c0f-85cd-0728e9803d3f" name="user-group" class="team-budget-icon"></yat-icon>
          <span [id]="id + '464024f5-22d5-4621-a25d-36d0b48a2f4f'" class="team-budget">{{
            'checkout.paymentInformation.paymentMethodPanel.teamBudget.label' | transloco
          }}</span>
        </p>
        <p [id]="id + '482bad70-ca3f-42ca-bf1d-8adf1b0f1836'" class="beside-icons" *ngIf="!minified">
          {{ paymentMethod.groupName }}
        </p>
        <p *ngIf="!minified" [id]="id + '75ae9548-49f5-4614-a724-7b42d3f7fffc'">
          <span [id]="id + '5615fa32-1231-45e6-b862-16a5e7703ed3'" class="c-gray mt-1 d-block">{{
            'checkout.paymentInformation.paymentMethodPanel.teamBudget.availableBudget'
              | transloco: { budget: paymentMethod.budget | translocoCurrency: 'symbol':{}:'EUR' }
          }}</span>
        </p>
        <div [id]="id + '05e1e360-b3ee-4da8-a537-129670fe8a0b'" class="panel-footer">
          {{ 'checkout.paymentInformation.paymentMethodPanel.teamBudget.issuedBy' | transloco: { issuedBy: paymentMethod.issuedBy } }}
        </div>
      </ng-container>
      <yat-icon id="82c15584-02ab-4907-8429-6a72bd252cc1" class="chevron-icon" *ngIf="isMobile() && minified; else cog" name="chevron-right"> </yat-icon>
      <ng-template #cog>
        <yat-icon id="13b900be-7c70-40ed-a9e0-6a422937380a" class="cog-icon" [class.demo-tag]="!liveLicense" *ngIf="!isMobile() && minified" name="cog-duo"></yat-icon>
      </ng-template>
    </div>
  </div>
  <yat-confirm-buttons
    [id]="id + '01326bef-1231-47a4-8034-32b562191981'"
    [confirmButtonName]="('delete' | commonWording | async) ?? ''"
    class="no-select"
    (confirmClickMethod)="delete($event)"
    (cancelClickMethod)="abortConfirmDelete()"
    *ngIf="deleteMode !== 'default' && !isMobile()"></yat-confirm-buttons>
  <div
    [id]="id + '3f55f7d5-9927-4f34-81b6-cee8eb45f260'"
    class="refused-payment"
    [class.minified]="minified"
    *ngIf="isPaymentMethod(paymentMethod) && paymentMethod.refusedPayment">
    <yat-icon name="warning-duo" [yatTooltip]="'checkout.paymentInformation.paymentMethodPanel.refusedPaymentWarning' | transloco" tooltipClass="tooltip-xl">
    </yat-icon>
  </div>
</div>
